<template>
  <div class="learingCourse">
      <backHeader back-addr="/person"></backHeader>
      <mt-navbar v-model="selected" style="margin-bottom:3px;">
        <mt-tab-item id="1" style="color:black;">思政微课</mt-tab-item>
        <mt-tab-item id="2" style="color:black;">思政工程</mt-tab-item>
      </mt-navbar>

      <mt-tab-container v-model="selected">

        <mt-tab-container-item id="1">
          <div id="myScroll" v-infinite-scroll="loadMoreNe" infinite-scroll-disabled="neLoadAll" infinite-scroll-distance="0" infinite-scroll-immediate-check="false">
                        <div class="" style="margin-left:8px;margin-right:8px;margin-bottom:12px;padding-top:8px;border-top:1px solid #AAABB0;" v-for="(ne,index) in nes">
                            <div style="display:flex;">
                                <div style="flex:2;">
                                    <img class="" :src="ne.schoolImg" style="height:18px;width:18px;vertical-align:text-top;margin-right:4px;">
                                    <span style="font-size: .6rem;">{{ne.schoolName}}</span>
                                </div>

                                <div style="flex:1;">
                                    <CollectElement v-bind:collect-data="ne" v-bind:collect-state="ne.collectionType" v-bind:collect-id="ne.id" v-bind:collect-type="'neCollect'"></CollectElement>
                                 </div>
                            </div>  
                            <div class=""  @click="goClassDetail(ne.link)">
                                <div class="">

                                </div>
                                <div class="">
                                    <h4 style="margin-left:17px;margin-right:17px;margin-top:12px;margin-bottom:12px;font-size: 18px;font-family: 'Helvetica Neue', Helvetica, STHeiTi, sans-serif;color: rgb(68, 85, 102);font-weight: bold;">{{ne.title}}</h4>
                                </div>
                            </div>
                            <div class=""  @click="goClassDetail(ne.link)">
                                <div class="">

                                </div>
                                <div class="" style="margin-left:17px;margin-right:17px;margin-top:8px;display:flex;flex-direction:row">
                                    <div v-for="image in ne.images" style="flex:1;">
                                       <img class="" :src="image" style="width:100%;height:100%;padding-left:2px;vertical-align:text-top;">
                                    </div>
                                </div>
                                <div style="height:4px;">

                                </div>
                            </div>
                        </div>
          </div>
        </mt-tab-container-item>

        <mt-tab-container-item id="2">
          <div id="myScroll" v-infinite-scroll="loadMoreSizheng" infinite-scroll-disabled="sizhengLoadAll" infinite-scroll-distance="0"  infinite-scroll-immediate-check="false">
                <div class="" style="margin-left:8px;margin-right:8px;margin-bottom:12px;padding-top:8px;border-top:1px solid #AAABB0;" v-for="(sizheng,index) in sizhengs">
                    <div  style="display:flex;">
                      
                        <div style="flex:2;">
                            <img class="" :src="sizheng.hospitalImg" style="height:18px;width:18px;vertical-align:text-top;margin-right:4px;">
                            <span style="font-size: .6rem;">{{sizheng.hospitalName}}</span>
                        </div>

                        <!-- <div class="mui-col-sm-3 mui-col-xs-3" @click="collect(index,sizheng)"> -->
                        <div style="flex:1;text-align:center;">
                            <!-- <img class="mui-media-object mui-pull-left" v-if="!sizheng.collectionType" :src="uncollection" style="height:18px;width:18px;vertical-align:text-top;margin-right:4px;">
                            <img class="mui-media-object mui-pull-left" v-if="sizheng.collectionType" :src="collection" style="height:18px;width:18px;vertical-align:text-top;margin-right:4px;">
                            <span>收藏</span> -->
                            <collect-element v-bind:collect-data="sizheng" v-bind:collect-state="sizheng.collectionType" v-bind:collect-id="sizheng.id" v-bind:collect-type="'sizhengCollect'"></collect-element>
                        </div>
                        <!-- <div class="mui-col-sm-4 mui-col-xs-3">
                            <img class="mui-media-object mui-pull-left" :src="comment" style="height:18px;width:18px;vertical-align:text-top;margin-right:4px;">
                            <span>(50)评论</span>
                        </div> -->
                    </div>
                    <div @click="goSizheng(sizheng.link)">
                    <div class="">
                        <div class="">

                        </div>
                        <div class="">
                            <h4 style="margin-left:17px;margin-right:17px;margin-top:12px;margin-bottom:12px;font-size:18px;font-family: 'Helvetica Neue', Helvetica, STHeiTi, sans-serif;color: #456;font-weight:bold;">{{sizheng.title}}</h4>
                        </div>
                        <div class="">

                        </div>
                    </div>
                    <div class="">
                        <div class="">

                        </div>
                        <div class="">
                            <p style="margin-left:17px;margin-right:17px;font-size:13px;font-family: 'Helvetica Neue', Helvetica, STHeiTi, sans-serif;color: #AAABB0;">{{limitLen(sizheng.content,100)}}</p>
                        </div>
                        <div class="">

                        </div>
                    </div>
                    <div class="">
                        <div class="">

                        </div>
                        <div class="" style="display:flex;margin-left:17px;margin-right:17px;margin-top:8px;">
                            <!-- <img class="mui-media-object mui-pull-left" v-for="image in sizheng.images" :src="image" style="width:100%;vertical-align:text-top;"> -->
                            <div v-for="image in sizheng.images" style="flex:1;padding-right:2px;margin-bottom:9px;">
                                <img class="" :src="image" style="width:100%;height:100%;padding-left:2px;vertical-align:text-top;">
                            </div>
                            
                             <!-- <img class="mui-media-object mui-pull-left" v-for="image in sizheng.images" :src="image" style="width:80px;height:70px;vertical-align:text-top;"> -->
                        </div>
                        <div class="">

                        </div>
                    </div>
                    </div>
                </div>
          </div>
        </mt-tab-container-item>
        
      </mt-tab-container>
  </div>
</template>
<script>
import CollectElement from "@/components/collect";
import crossLine from "./../components/cross-line.vue";
import backHeader from "./../components/back-header.vue";
// import IndexApi from '../api/learingInd.js'
import cfg from "./../utils/config";
import axios from "axios";
import Addr from "./../utils/getAPI";
import store from "@/store/index";
import { Toast } from "mint-ui";

export default {
  name: "learingCourse",
  data() {
    return {
      nes: [
        
      ],
      sizhengs: [
        
      ],
      selected: "1",
      pageRowNe: 11,
      pageNumNe: 1,
      pageRowSizheng: 11,
      pageNumSizheng: 1,
      neLoadAll:false,
      sizhengLoadAll:false
    };
  },
  methods: {
    goSizheng(link) {
      window.location.href=link;
    },
    goClassDetail(link) {
       window.location.href=link;
    },
    //限制长度
    limitLen(content, maxLen) {
      return content.length > maxLen
        ? content.slice(0, maxLen) + "..."
        : content + "...";
    },
    initNeData() {
      axios
        .get(
          Addr.getGoAPIPrefix() +
            "ne/listNeCollect?pageNum="+this.pageNumNe+"&pageRow="+this.pageRowNe+"&id=" +
            this.$store.state.mineStore.userId
        )
        .then(res => {
          console.log("res is:");
          console.log(res);
          if (res.data.returnCode == 100) {
            //先清空
            this.nes = null;
            this.nes = res.data.returnData.list;
            console.log("this list is:", this.list);

            //如果没有收藏，则不显示
            if (this.nes == null) {
              mui.toast("没有收藏的思政微课！");
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    initSizhengData() {
      axios
        .get(
          Addr.getGoAPIPrefix() +
            "sizheng/listSizhengCollect?pageNum="+this.pageNumSizheng+"&pageRow="+this.pageRowSizheng+"&id=" +
            this.$store.state.mineStore.userId
        )
        .then(res => {
          console.log("res is:");
          console.log(res);
          if (res.data.returnCode == 100) {
            //先清空
            this.sizhengs = null;
            this.sizhengs = res.data.returnData.list;
            console.log("this list is:", this.list);

            //如果没有收藏，则不显示
            if (this.sizhengs == null) {
              mui.toast("没有收藏的思政工程！");
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    loadMoreNe() {
      if (this.neLoadAll == true) {
        Toast({
          message: "已全部加载",
          position: "bottom",
          duration: 800
        });
        return;
      }
      this.pageNumNe++;

      axios
        .get(
          Addr.getGoAPIPrefix() +
             "ne/listNeCollect?pageNum="+this.pageNumNe+"&pageRow="+this.pageRowNe+"&id=" +
            this.$store.state.mineStore.userId
        )
        .then(res => {
          console.log("res is:");
          console.log(res);
          if (res.data.returnCode == 100) {
            if (res.data.returnData.list == null) {
              this.neLoadAll = true;
              Toast({
                message: "已全部加载",
                position: "bottom",
                duration: 800
              });
            } else {
              Toast({
                message: "已加载",
                position: "bottom",
                duration: 800
              });
              this.nes.push.apply(this.nes, res.data.returnData.list);
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    loadMoreSizheng() {
      if (this.sizhengLoadAll == true) {
        Toast({
          message: "已全部加载",
          position: "bottom",
          duration: 800
        });
        return;
      }
      this.pageNumSizheng++;

      axios
        .get(
          Addr.getGoAPIPrefix() +
             "sizheng/listSizhengCollect?pageNum="+this.pageNumSizheng+"&pageRow="+this.pageRowSizheng+"&id=" +
            this.$store.state.mineStore.userId
        )
        .then(res => {
          console.log("res is:");
          console.log(res);
          if (res.data.returnCode == 100) {
            if (res.data.returnData.list == null) {
              this.sizhengLoadAll = true;
              Toast({
                message: "已全部加载",
                position: "bottom",
                duration: 800
              });
            } else {
              Toast({
                message: "已加载",
                position: "bottom",
                duration: 800
              });
              this.sizhengs.push.apply(this.sizhengs, res.data.returnData.list);
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
  },
  mounted: function() {
    document.getElementById("myScroll").style.minHeight=(window.innerHeight+39)+"px";
  },
  created:function(){
    this.initNeData();
    this.initSizhengData();
  },
  components: {
    crossLine,
    backHeader,
    CollectElement
  }
};
</script>

<style lang="scss">
@import "../assets/baseScss";
.mint-navbar .mint-tab-item.is-selected {
  color: #e70202 !important;
  border-bottom: 2px solid #e70202 !important;
}

.banner {
  background-size: cover;
  width: 100%;
  min-height: 100%;
}

.learingCourse {
  .courseItem {
    .item {
      display: flex;
      padding: 15px 15px 0px;

      .ico {
        flex: 1;
        margin-right: 10px;
      }
      .info {
        flex: 2;
        position: relative;
        .tit {
          text-align: left;
          height: 40px;
          line-height: 40px;
          overflow: hidden;
        }
        .speed {
          display: flex;
          font-size: 14px;
          line-height: 30px;
          margin-top: 5px;
          width: 100%;
          a {
            flex: 2;
            color: $cl0;
            text-align: right;
            font-weight: 500;
            i:before {
              position: relative;
              top: 1px;
            }
          }
          .mt-progress {
            flex: 3;
            color: $cl9;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/module-person/collection.vue